import { snackbarService } from "@one/web-components/dist/index.cjs.js";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { SNACKBAR_DURATION } from "../../components/EquipmentList/Constants/constants";
import { useSelector } from "react-redux";
import { signOut } from "../../utils/signout";

const useSecondaryAuth = ({ client, loading }) => {
  const storeUser = useSelector((store) => store.user);
  const isPredUser = storeUser.isPredUser;
  const history = useHistory();
  useEffect(() => {
    if (loading || !isPredUser) {
      return
    }

    const secondaryAuthUrl = process.env.REACT_APP_SECONDARY_AUTH_URL;
    if (!secondaryAuthUrl) {
      console.log('missing secondaryAuthUrl')
    }

    const exchangeCodeForToken = async () => {
      try {
        const response = await fetch(`${secondaryAuthUrl}/auth/token`, {
          method: "GET",
          credentials: "include",
          mode: "cors",
        });

        const data = await response.json();
        const accessToken = data?.data?.accessToken;
        const statusCode = data?.statusCode ?? response.status;

        if (statusCode === 401) {
          snackbarService.show({
            message: "Unauthorized or refresh token expired, try again or contact support.",
            type: "error",
            duration: SNACKBAR_DURATION * 4
          });
          await signOut(client, storeUser, false);
        }
        if (statusCode === 503) {
          history.push("/")
          snackbarService.show({
            message: "Redpanda is unavailable, only manual project list is available.",
            type: "error",
            duration: SNACKBAR_DURATION
          });
        }
        if (statusCode === 500) {
          history.push("/login-error")
          snackbarService.show({
            message: "Internal Server Error - Contact Support",
            type: "error",
            duration: SNACKBAR_DURATION
          });
        }
        if (accessToken) {
          localStorage.setItem("secondaryAuthAccessToken", accessToken);
          history.push("/");
        }
      } catch (error) {
        console.error("Authentication Error:", error);
        snackbarService.show({
          message: "Authentication Error, try again or contact support.",
          type: "error",
          duration: SNACKBAR_DURATION
        });
        // redirect here for now to not get stuck in a loop
        history.push("/login-error");
      }
    };

    const urlParams = new URLSearchParams(window.location.search);
    // status could be additional security measure to ensure the request is valid
    const status = urlParams.get("initialLoginStatus");
    if (status === "success") {
      // Clear the status from the URL
      history.replace("/");
      exchangeCodeForToken();
    } else {
      const secondaryToken = localStorage.getItem("secondaryAuthAccessToken");
      if (!secondaryToken) {
        window.location.href = `${secondaryAuthUrl}/auth/login`;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history, loading]);
};

export default useSecondaryAuth;
